import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const hero = document.getElementById('hero');
      const finalCta = document.getElementById('final-cta');
      if (!hero) return;
      const heroBottom = hero.getBoundingClientRect().bottom;
      const finalRect = finalCta?.getBoundingClientRect();
      // Show after scrolling past hero, hide when final CTA is in viewport
      const pastHero = heroBottom < 0;
      const finalVisible = finalRect ? finalRect.top < window.innerHeight && finalRect.bottom > 0 : false;
      setVisible(pastHero && !finalVisible);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-171">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-40 border-t border-pinkLight bg-cream px-4 py-3 shadow-[0_-4px_16px_rgba(75,21,40,0.08)] md:hidden" data-id="element-172">
          <a href="https://vitalizateahora.com/cart/52084969832679:1" target="_top" rel="noopener" className="flex w-full items-center justify-center gap-2 rounded-[8px] bg-wine px-6 py-4 text-[16px] font-medium text-white no-underline transition-colors hover:bg-[#3a1020] active:scale-[0.99]" data-id="element-173">
            Quiero mi guía ahora · $10
          </a>
        </motion.div>}
    </AnimatePresence>;
}